import { render } from "./FormEditCourse.vue?vue&type=template&id=3fb7ba58&scoped=true"
import script from "./FormEditCourse.vue?vue&type=script&lang=js"
export * from "./FormEditCourse.vue?vue&type=script&lang=js"

import "./FormEditCourse.vue?vue&type=style&index=0&id=3fb7ba58&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vue-soft/vue-soft/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fb7ba58"]])

export default __exports__